import Typography from "@mui/material/Typography";
import HamburgerMenu from "../../utilities/hamburgerMenu";
import { useCallback, useEffect, useState } from "react";
import StyledDrawer from "./drawer";
import { FontFamilies } from "../../../utilities/styles";
import {
  StyledToolbar,
  StyledBoxRowForNavbar,
  ToolbarTextContainer,
} from "./styles";

export default function StyledNavbar() {
  const [open, setDrawerState] = useState(false);
  const [navbarContainerHeight, setNavbarContainerHeight] = useState(0);

  const handleDrawerClose = useCallback(
    (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event.type === "keydown" &&
        ((event as React.KeyboardEvent).key === "Tab" ||
          (event as React.KeyboardEvent).key === "Shift")
      ) {
        return;
      }
      setDrawerState(false);
    },
    []
  );

  const toggleDrawer = useCallback(() => {
    setDrawerState((prev) => !prev);
  }, []);

  const updateNavbarContainerHeight = useCallback(() => {
    const newHeight = document.getElementById(
      "NavbarContentContainer"
    )?.offsetHeight;
    if (newHeight) {
      setNavbarContainerHeight((prev) =>
        newHeight !== prev ? newHeight : prev
      );
    }
  }, []);

  useEffect(() => {
    updateNavbarContainerHeight();
    window.addEventListener("resize", updateNavbarContainerHeight);
    return () => {
      window.removeEventListener("resize", updateNavbarContainerHeight);
    };
  }, [updateNavbarContainerHeight]);

  useEffect(() => {
    updateNavbarContainerHeight();
  }, [open, updateNavbarContainerHeight]);
  return (
    <div id="NavbarContainer" style={{ height: navbarContainerHeight + "px" }}>
      <StyledToolbar id="NavbarContentContainer" open={open}>
        <StyledBoxRowForNavbar>
          <HamburgerMenu
            onClick={toggleDrawer}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                toggleDrawer();
              }
            }}
            role="button"
            tabIndex={0}
            aria-label="Toggle navigation menu"
            aria-expanded={open}
            aria-controls="NavbarDrawer"
          />
          <ToolbarTextContainer>
            <Typography
              variant="h6"
              component="div"
              fontFamily={FontFamilies.SansProRegular}
              fontWeight="600"
            >
              St. George Coptic Church Chicago
              <Typography
                variant="body1"
                noWrap
                component="div"
                fontFamily={FontFamilies.SansProRegular}
              >
                Monee, IL
              </Typography>
            </Typography>
          </ToolbarTextContainer>
          {/* <SearchBar /> */}
        </StyledBoxRowForNavbar>
      </StyledToolbar>
      {/* Sidebar Navigation can be found here */}
      <StyledDrawer
        open={open}
        onClose={handleDrawerClose}
      />
    </div>
  );
}
